// extracted by mini-css-extract-plugin
export default {"custom_btn":"forgotPassword_custom_btn__oR1Vs"};